import { makeStyles } from '@material-ui/core/styles';

export default makeStyles((theme) => ({
  root: ({ provider }) => ({
    textTransform: 'capitalize',
    fontSize: 16,
    fontWeight: 400,
    [theme.breakpoints.down('sm')]: {
      fontSize: 14,
    },
    '.rtl & svg': {
      transform: 'rotate(180deg)',
    },
    touchAction: 'manipulation',
    color: provider ? '#0C9BED' : 'unset',
    textDecoration: provider ? 'underline !important' : 'unset',
    '& :hover': {
      textDecoration: provider ? 'underline !important' : 'unset',
    },
  }),
}));
